import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { isAuthenticated } from '../../../../services/auth';
import { removeFavourite } from '../../../../services/product';
import { userFavouriteProducts, viewUser } from '../../../../services/user';
import UnifiedDashboard from '../../../../components/layout/UnifiedDashboard';
import OptimizedList from '../../../../components/ui/lists/OptimizedList';
import ProductCard from '../../../../components/product/ProductCard';
import { useDispatch } from 'react-redux';
import { message, Tooltip } from 'antd';
import './Favourites.css';

const Favourites = () => {
  const dispatch = useDispatch();
  const countPerPage = 5;
  const [values, setValues] = useState({
    followers: '',
    following: '',
  });
  const [favourite, setFavourite] = useState(false);
  const [favourites, setFavourites] = useState([]);
  const [current, setCurrent] = useState(1);
  const [pagination, setPagination] = useState([]);
  const [positiveRatings, setpositiveRatings] = useState([]);
  const [negativeRatings, setnegativeRatings] = useState([]);
  const positiveRating = [];
  const negativeRating = [];

  const { followers, following } = values;
  const { user, token } = isAuthenticated();

  const loadFavouriteProducts = async (page) => {
    let res = await userFavouriteProducts(user._id);
    setCurrent(page);
    const to = page * countPerPage;
    const from = to - countPerPage;
    setPagination(res.data.slice(from, to));
    setFavourites(res.data);
  };

  const loadUser = async () => {
    let res = await viewUser(user._id);
    res.data.ratings.forEach((item) => {
      if (item.rating === 'positive') {
        positiveRating.push(item._id);
        setpositiveRatings(positiveRating);
      } else if (item.rating === 'negative') {
        negativeRating.push(item._id);
        setnegativeRatings(negativeRating);
      }
    });
    setValues({
      followers: res.data.followers,
      following: res.data.following,
    });
  };

  useEffect(() => {
    loadUser();
    loadFavouriteProducts(1);
  }, [favourite]);

  const handleRemoveFavourite = async (productId) => {
    const res = await removeFavourite(productId, { user, token });
    dispatch({ type: 'USER_DETAILS', payload: res.data });
    message.error('Removido dos Favoritos');
    setFavourite((f) => !f);
  };

  const API = (process.env.REACT_APP_API ).replace(/\/api$/, '');

  // Helper para buscar nome da localização (ajuste conforme necessário)
  const getLocationName = (location) => {
    if (!location) return null;
    if (location.name) return location.name;
    return location;
  };

  function renderProductCard(product) {
    return (
      <ProductCard
        key={product._id}
        product={product}
        showActions={false}
        showAuthor={true}
        isAdmin={false}
        getLocationName={getLocationName}
        onRemoveFavourite={() => handleRemoveFavourite(product._id)}
        API={API}
        isFavourite={true}
      />
    );
  }

  return (
    <UnifiedDashboard title="Favoritos" data={{ user, followers: followers?.length || 0, following: following?.length || 0, favourites: favourites?.length || 0 }}>
      <div className='favourites-content dashboard-content'>
        <div className='d-flex justify-content-between align-items-center mb-4'>
          <div>
            <h2 className='mb-1'>Meus Favoritos</h2>
            <p className='text-muted mb-0'>Produtos que você marcou como favorito</p>
          </div>
          <Link to='/user/dashboard' className='btn btn-outline-primary rounded-3 px-4'>
            <Tooltip title='Voltar para o Dashboard'>
              <i className='fas fa-arrow-circle-left'></i>
            </Tooltip>
          </Link>
        </div>
        <OptimizedList
          data={pagination}
          loading={false}
          pageSize={countPerPage}
          current={current}
          total={favourites.length}
          onPageChange={loadFavouriteProducts}
          renderItem={renderProductCard}
          emptyText='Nenhum produto favorito encontrado'
        />
      </div>
    </UnifiedDashboard>
  );
};

export default Favourites;
